
<router-outlet (activate)="moveUp()"></router-outlet>